import React from "react";
import AddPolls from "../../Administrative/AddPolls";

const AddYuvasarthiPolls = () => {
  return (
    <div>
      <AddPolls role="Super Admin" />
    </div>
  );
};

export default AddYuvasarthiPolls;
